import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import AuthService from '../../../business-api/AuthService'

import {
    formataArrayData,
} from '../../../business-components/Date/Date'

import {
    GridContainer,
    GridItem3,
    GridItem9,
} from '../../../business-components/Grid/Grid'

import {
    MUIDataTablePadrao
} from '../../../business-components/MUIDataTable/MUIDataTable'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import instituicaoFinanceiraList from '../../../business-rules/List/instituicaoFinanceiraList'

import tipoArquivoList from '../../../business-rules/List/Arquivo/tipoArquivoList'

import tipoSolicitacaoArquivoList from '../../../business-rules/List/Arquivo/tipoSolicitacaoArquivoList'

import {
    UploadFileUploadArquivos,
    VisualizarArquivo,
    ExclusaoArquivo,
} from './AcompanhamentoCompArquivo'



const AcompanhamentoFormArquivo = ({ variaveisGlobais, values, vars, arquivoList, obterArquivoList }) => {

    const columns = [
        {
            name: 'nomeArquivo',
            label: LABEL.nomeArquivo,
        },
        {
            name: 'tipoArquivo',
            label: LABEL.tipoArquivo,
            options: {
                filter: true,
                customBodyRenderLite: (dataIndex) => {

                    return (
                        pesquisaList(tipoArquivoList, arquivoList[dataIndex]?.tipoArquivo).descricao
                    )
                },
            },
        },
        {
            name: 'instituicaoFinanceira',
            label: LABEL.instituicaoFinanceira,
            options: {
                filter: true,
                customBodyRenderLite: (dataIndex) => {

                    return (
                        pesquisaList(instituicaoFinanceiraList, arquivoList[dataIndex]?.instituicaoFinanceira).descricao
                    )
                },
            },
        },
        {
            name: 'tipoSolicitacaoArquivo',
            label: LABEL.tipoSolicitacaoArquivo,
            options: {
                filter: true,
                customBodyRenderLite: (dataIndex) => {

                    return (
                        pesquisaList(tipoSolicitacaoArquivoList, arquivoList[dataIndex]?.tipoSolicitacaoArquivo).descricao
                    )
                },
            },
        },
        {
            name: 'dataHoraAlteracao',
            label: LABEL.data,
            options: {
                filter: true,
                customBodyRenderLite: (dataIndex) => {

                    return (
                        formataArrayData(arquivoList[dataIndex]?.dataHoraAlteracao)
                    )
                },
            },
        },
        {
            name: 'id',
            label: ' ',
            options: {
                download: false,
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <GridContainer>
                            <GridItem9>
                                <VisualizarArquivo
                                    variaveisGlobais={variaveisGlobais}
                                    arquivoCliente={arquivoList[dataIndex]}
                                />
                            </GridItem9>
                            <GridItem3>
                                {!AuthService.obterAcessoCliente(variaveisGlobais) && (
                                    <ExclusaoArquivo
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        arquivoCliente={arquivoList[dataIndex]}
                                        obterArquivoList={obterArquivoList}
                                    />
                                )}
                            </GridItem3>
                        </GridContainer>
                    )
                },
            },
        },
    ]
    

    
    return (
        <MUIDataTablePadrao
            //breadcrumbRouteSegments={[
            //    { name: LABEL.pageClienteList, path: PATH.pageClienteList },
            //    { name: LABEL.pageIntegracaoClienteArquivoList},
            //]}
            title={''}
            data={arquivoList}
            columns={columns}
             customToolbar={() => {
                return (
                    //AuthService.obterUsuarioSelecionado(variaveisGlobais) &&
                    //AuthService.obterUsuarioSelecionado(variaveisGlobais).length === 1
                    //    ?
                            <UploadFileUploadArquivos
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                vars={vars}
                                obterArquivoList={obterArquivoList}
                                idTipoSolicitacaoArquivo={null}
                                tipoSolicitacaoArquivo={null}
                            />
                    //    :
                    //        ''
                )
            }}
        />
    )
}

export default AcompanhamentoFormArquivo
